import * as React from "react";

import { Layout } from "../../src/components/Layout";

export default function TopLayout(props) {
  return <Layout>{props.children}</Layout>;
}
